// extracted by mini-css-extract-plugin
export var pillWrapper = "_pj-0";
export var showOverflow = "_pj-1";